const LazyLoad = require('vanilla-lazyload');

/*
******** DISABLED IN SF-1716 **********
const citiesHightlights = {
  current: 'london',
  cities: [],
};

const citiesHlElement = () => document.querySelector('.store-locator__cities-highlights');
const cityHightlightElement = () => document.querySelector('.store-locator__store-address');

const getCityAddressByCity = (pc) => citiesHightlights.cities.find(({ city }) => pc === city);
const getCurrentAddress = () => getCityAddressByCity(citiesHightlights.current);

const searchStoresByCity = (city, country) => {
  document.querySelector('#store-postal-code').value = city.charAt(0).toUpperCase() + city.slice(1);
  document.querySelector(`#storeselector-select-country>.field-select__option[value=${country}]`).selected = true;
  document.querySelector('.btn-storelocator-search[type="button"]').click();
};

const updateHigLightAddress = function updateHigLightAddress() {
  const { address, city, country } = getCurrentAddress();
  cityHightlightElement().querySelector('h4').innerHTML = city;
  cityHightlightElement().querySelector('p').innerHTML = address;
  searchStoresByCity(city, country);
};
*/

module.exports = {
  init() {
    window.theStoresLazyLoad = new LazyLoad({
      elements_selector: '.store-locator__store-image.lazy',
      class_loading: 'store-locator__store-image--loading',
      class_loaded: 'store-locator__store-image--loaded',
      thresholds: '200% 0px',
    });

    /*
    ******** DISABLED IN SF-1716 **********
    if (!citiesHlElement()) return;
    citiesHightlights.cities = Array.from(citiesHlElement().querySelectorAll('li>a[data-city]'))
      .map(({ dataset: { city, address, country } }) => ({ city, address, country }));

    citiesHightlights.current = cityHightlightElement().dataset?.city;

    citiesHlElement().addEventListener('click', (e) => {
      if (!e.target.dataset?.city) return;
      citiesHightlights.current = e.target.dataset.city;
      updateHigLightAddress();
    });
     */
  },
};
